export enum StockStatusEnum {
  IN_STOCK = 'inStock',
  LOW_STOCK = 'lowStock',
  MAX_ORDER = 'maxOrderQuantityExceeded',
  NO_STOCK = 'noStock',
  OUT_OF_STOCK = 'outOfStock'
}

export enum StockAvailabilityEnum {
  IN_STOCK = 'yes',
  LOW_STOCK = 'low stock',
  NO_STOCK = 'no',
  NOT_ON_SALE = 'not on sale'
}
